const DEFAULT_MUI_COLOR = "#006651";

/** Minimal hex color pattern: # plus 3 or 6 hex digits */
const HEX_COLOR_REGEX = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

/**
 * Sanitizes a value for use as an MUI theme color (e.g. palette.primary.main).
 * Prevents MUI error #9 ("Unsupported color") when the API returns null, the
 * string "null", or other invalid values.
 *
 * @param value - Raw color from API or form (may be null, undefined, "", "null", or invalid)
 * @param fallback - Color to return when value is invalid (default: "#006651")
 * @returns A valid hex color string for MUI
 */
export function toValidMuiColor(
  value: string | null | undefined,
  fallback: string = DEFAULT_MUI_COLOR
): string {
  if (value == null || value === "") {
    return fallback;
  }
  const trimmed = String(value).trim();
  if (trimmed === "" || trimmed.toLowerCase() === "null") {
    return fallback;
  }
  return HEX_COLOR_REGEX.test(trimmed) ? trimmed : fallback;
}
